import { useMemo } from 'react';
import { useGetDeliverObject } from '../api/deliver-object-api/deliver-object-api';
import { DeliverObjectDto, ProjectDto } from '../api/model';
import { useProjectPhases } from './useProjectPhases';


export const useProjectDeliverables = (project?: ProjectDto) => {
  // Fetch all deliverables
  const { 
    data: allDeliverablesData, 
    isLoading: isDeliverablesLoading, 
    error: deliverablesError 
  } = useGetDeliverObject({
    query: {
      staleTime: 0,
      refetchOnMount: true,
      gcTime: 10 * 60 * 1000,
      refetchOnWindowFocus: false,
      refetchInterval: false,
      refetchIntervalInBackground: false,
      retry: 2,
      retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
    }
  });
  
  // Fetch phases for this project
  const { 
    data: projectPhases, 
    isLoading: isPhasesLoading 
  } = useProjectPhases(project?.id);
  
  const projectDeliverables = useMemo(() => {
    if (!allDeliverablesData || !project) {
      return [];
    }
    
    // collection id for phases in this project, so we can use other components when needed.
    const projectPhaseIds = new Set();
    if (projectPhases) {
      projectPhases.forEach(phase => {
        if (phase.id) {
          projectPhaseIds.add(phase.id);
        }
      });
    }
    
    if (projectPhaseIds.size === 0) {
      return [];
    }

    return allDeliverablesData.filter((deliverable: DeliverObjectDto) => {
      const deliverableAny = deliverable as any;
      const phaseId = deliverableAny.phase_id || deliverableAny.phaseId;
      return phaseId && projectPhaseIds.has(phaseId);
    });
  }, [allDeliverablesData, project, projectPhases]);

  return {
    deliverables: projectDeliverables,
    isLoading: isDeliverablesLoading || isPhasesLoading,
    error: deliverablesError,
    hasData: projectDeliverables.length > 0
  };
};